import React, { useEffect, useRef } from 'react';
import MachineGeneral from './MachineGeneral';
import MachineMap from './MachineMap';
import MachineStats from './MachineStats';
import { makeStyles, Container, Grid, Theme } from '@material-ui/core';
import { useSelector, useDispatch } from 'react-redux';
import { RouteComponentProps as IRouteComponentProps } from 'react-router-dom';
import { AccessLevel, IReduxState } from '../../types';
import MachineErrors from './MachineErrors';
import FuelGraphLine from './FuelLevels/FuelGraphLine';
import FuelGraphGauges from './FuelLevels/FuelGraphGauges';
import GraphControls from './GraphControls';
import { fetchMachineDetails } from '../../actions/machineDetailsActions';
import EngineUtilizationLine from './EngineUtilization/EngineUtilizationLine';
import EngineUtilizationGauge from './EngineUtilization/EngineUtilizationGauge';
import FuelConsumptionLine from './FuelConsumption/FuelConsumptionLine';
import FuelConsumptionDisplay from './FuelConsumption/FuelConsumptionDisplay';
import ThroughputDisplay from './Throughput/ThroughputDisplay';
import ThroughputLine from './Throughput/ThroughputLine';
import EngineSpezificationLine from './EngineUtilization/EngineSpezificationLine';
import EngineCrusherDrivePressureLine from './EngineUtilization/EngineCrusherDrivePressure';
import MachineTagsNotes from './MachineTagsNotes';
import { useIdle } from '../useIdle';
import { handleUserIdle } from '../../actions/authActions';
import { MachineImage } from './MachineImage';
import { SkeletonLoaderPdf } from './SkeletonLoaders/';
import EngineUtilizationGaugeHybrid from './EngineUtilization/EngineUtilizationGaugeHybrid';
import FuelConsumptionDisplayHybrid from './FuelConsumption/FuelConsumptionDisplayHybrid';
import PerformanceIndicatorGraphGauge from './PerformanceIndicators/PerformanceIndicatorGauge';
import PdfReport from './PdfReport';
import { useWindowSize } from '../useWindowSize';
import { useTranslation } from 'react-i18next';
import MachineGeneralData from './MachineGeneralData';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    // marginTop: `${theme.spacing(2)}px`,
    flexGrow: 1,
  },
  // Abstand f�r den ersten Block (obere 4 Karten)
  firstSection: {
    marginTop: theme.spacing(4),        // +32px nach unten
  },
  topBlock: {
    backgroundColor: 'red',
  },
  report: {
    [theme.breakpoints.up('xs')]: {
      margin: `${theme.spacing(4)}px 0`,
    },
    [theme.breakpoints.up('sm')]: {
      margin: `${theme.spacing(2)}px`,
    },
    '@media print': {
      margin: `${theme.spacing(2)}px`,
    },
  },
  graphControls: {
    top: 0,
    width: '100%',
    zIndex: 100,
    [theme.breakpoints.up('sm')]: {
      position: 'relative',
      marginTop: theme.spacing(4),
    },
  },
}));

export default function MachineDetails(props: IRouteComponentProps<any>) {
  const windowSize = useWindowSize();
  const isMobile = !!windowSize && !!windowSize.width && windowSize.width < 601;
  const classes = useStyles();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const machineId = props.match.params.id;

  const machineDetails = useSelector((state: IReduxState) => state.machineDetails);

  const hasWeightData : boolean = useSelector(
    (state: IReduxState) => !!state.machineDetails.machine.hasWeightData
  );

  const totalWeightLoad1 = useSelector(
    (state: IReduxState) => state.machineDetails.totalWeightLoad1
  );

  const totalWeightLoad2 = useSelector(
    (state: IReduxState) => state.machineDetails.totalWeightLoad2
  );
  // const totalWeightLoad3 = useSelector(
  //   (state: IReduxState) => state.machineDetails.totalWeightLoad3
  // );
  // const totalWeightLoad4 = useSelector(
  //   (state: IReduxState) => state.machineDetails.totalWeightLoad4
  // );

  const weightDataContent: boolean =
     (totalWeightLoad1?.value ?? 0) > 0 
  || (totalWeightLoad2?.value ?? 0) > 0;

  // console.log("hasWeightData : " + hasWeightData);
  // console.log("weightDataContent : " + weightDataContent);
  // console.log("totalWeightLoad1 : " + totalWeightLoad1);
  // console.log(totalWeightLoad1);
  // console.log("totalWeightLoad2 : " + totalWeightLoad2);
  // console.log(totalWeightLoad2);

  const {
    machine,
    isCreatingPdf,
  } = machineDetails;
  const { info } = machine;
  
  // console.warn("****************************************");
  // console.warn("Index");
  // console.warn("****************************************");
  // console.log("########################################");
  // console.warn("In Index");
  // console.warn(info);
  // console.log("########################################");
  
  // const isHybrid = machine.telemetrySnapshot?.isHybrid ?? false;
  const isHybrid = machine.isHybrid ?? false;

  console.log("***************************");
  console.log("Machine : ");
  console.log(machine);
  console.log("***************************");

  const isThirdParty = machine.machineType.isThirdParty;
  const hasJawCloseSideSetting = machine.machineType.hasJawCloseSideSetting ?? false;

  console.log("hasJawCloseSideSetting : " + hasJawCloseSideSetting);

  const isIdle = useIdle();

  // Get all machines on mount
  useEffect(() => {
    dispatch(fetchMachineDetails(machineId));
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    dispatch(handleUserIdle(isIdle));
  }, [isIdle, dispatch]);

  // PDF REPORT
  // chart refs are needed for using images in PDF Report
  const fuelGaugesRef = useRef<HTMLDivElement>(null);
  const fuelLevelsRef = useRef<HTMLDivElement>(null);
  const engineUtilizationGaugeRef = useRef<HTMLDivElement>(null);
  const engineUtilizationRef = useRef<HTMLDivElement>(null);
  const fuelConsumptionDisplayRef = useRef<HTMLDivElement>(null);
  const fuelConsumptionLineRef = useRef<HTMLDivElement>(null);
  const performanceIndicatorGaugeRef = useRef<HTMLDivElement>(null);
  const throughputDisplayRef = useRef<HTMLDivElement>(null);
  const throughputLineRef = useRef<HTMLDivElement>(null);
  const engineCrusherDrivePressureLineRef = useRef<HTMLDivElement>(null);
  const engineCloseSideSettingLineRef = useRef<HTMLDivElement>(null);
  const machineImgRef = useRef<HTMLImageElement>(null);
  // only hybrid machines
  const engineUtilizationGaugeHybridRef = useRef<HTMLDivElement>(null);
  const fuelConsumptionDisplayHybridRef = useRef<HTMLDivElement>(null);

  const hasJawPressure = machine.machineType.hasJawPressure ?? false;
  console.log("Index: hasJawPressure : " + hasJawPressure);

  const createReport = async () => {
    const report = new PdfReport(
      dispatch,
      t,
      isMobile,
      machineDetails,
    );

    report.createReport(
      fuelGaugesRef,
      fuelLevelsRef,
      engineUtilizationGaugeRef,
      engineUtilizationRef,
      fuelConsumptionDisplayRef,
      fuelConsumptionLineRef,
      performanceIndicatorGaugeRef,
      throughputDisplayRef,
      throughputLineRef,
      machineImgRef,
      engineUtilizationGaugeHybridRef,
      fuelConsumptionDisplayHybridRef,
      engineCloseSideSettingLineRef,
      engineCrusherDrivePressureLineRef,
      hasWeightData || weightDataContent,
      hasJawPressure
    );
  };

  return (
    <Container maxWidth="xl">
      {/* {console.warn("In Container")} */}
      <div className={classes.root}>
        {isCreatingPdf ? <SkeletonLoaderPdf /> : null}
        {machine ? (
          <Grid container className={classes.firstSection}>
            <div className={classes.graphControls}>
              {/* <Grid item xs={12} sm={6} md={6} lg={3}> */}
                <MachineGeneralData onCreateReport={createReport}/>
              {/* </Grid> */}
            </div>
            {/* <div className={classes.graphControls}>
              <GraphControls onCreateReport={createReport} />
            </div> */}
            <Grid item xs={12} sm={6} md={6} lg={3}>
              <MachineGeneral/>
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={3}>
              <MachineStats />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={3}>
              <MachineTagsNotes />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={3}>
              <MachineMap />
            </Grid>

            {/* <Grid item xs={12} sm={6} md={6} lg={3}> */}
              <div className={classes.graphControls}>
                <GraphControls onCreateReport={createReport} />
              </div>
            {/* </Grid> */}

            {/* Display Charts */}
            {!isThirdParty && (
              <Grid item xs={12} sm={6} md={6} lg={3}>
                <ThroughputDisplay />
              </Grid>
            )}

            <Grid item xs={12} sm={6} md={6} lg={3}>
              {isHybrid ? (
                <EngineUtilizationGaugeHybrid />
              ) : (
                <EngineUtilizationGauge />
              )}
            </Grid>

            <Grid item xs={12} sm={6} md={6} lg={3}>
              {isHybrid ? (
                <FuelConsumptionDisplayHybrid />
              ) : (
                <FuelConsumptionDisplay />
              )}
            </Grid>
            
            <Grid item xs={12} sm={6} md={6} lg={3}>
              {/*isHybrid ? <MachineEnergySavings /> : <FuelGraphGauges />*/}
              <PerformanceIndicatorGraphGauge />
            </Grid>

            {/* Line Charts */}
            {!isThirdParty && (
              <Grid item xs={12}>
                <ThroughputLine />
              </Grid>
            )}
            <Grid item xs={12}>
              <EngineUtilizationLine />
            </Grid>

            {hasJawPressure && (
              <Grid item xs={12}>
                <EngineCrusherDrivePressureLine />
              </Grid>
            )}

            <Grid item xs={12}>
              <FuelConsumptionLine />
            </Grid>

            {hasJawCloseSideSetting &&
              <Grid item xs={12}>
                <EngineSpezificationLine />
              </Grid>
            }

            <Grid item xs={12}>
              <FuelGraphLine />
            </Grid>

            {/* TODO: Errors are not yet handled in third party machines */}
            {!isThirdParty && (
              <Grid item xs={12}>
                <MachineErrors startRowsPerPage={5} />
              </Grid>
            )}

            {/* For PDF Report only */}
            <div
              style={{
                display: 'flex',
                position: 'absolute',
                top: -100000,
              }}
            >
              <img
                ref={machineImgRef}
                alt={machine.machineType.name}
                src={MachineImage(machine.machineType, isHybrid)}
              />

              <div
                style={{
                  position: 'absolute',
                  top: 0,
                  // top: -100000,
                  width: 300,
                  height: 550,
                }}
                ref={fuelGaugesRef}
              >
                <FuelGraphGauges />
              </div>

              <div
                style={{
                  position: 'absolute',
                  top: 0,
                  // top: -100000,
                  width: 800,
                  height: 550,
                }}
                ref={fuelLevelsRef}
              >
                <FuelGraphLine isPdfReport />
              </div>
              <div
                style={{
                  position: 'absolute',
                  top: 0,
                  // top: -100000,
                  width: 300,
                  height: 550,
                }}
                ref={engineUtilizationGaugeRef}
              >
                <EngineUtilizationGauge />
              </div>

              {/* Only used for hybrid machines */}
              <div
                style={{
                  position: 'absolute',
                  top: 0,
                  // top: -100000,
                  width: 300,
                  height: 550,
                }}
                ref={engineUtilizationGaugeHybridRef}
              >
                <EngineUtilizationGaugeHybrid isPdfReport />
              </div>
              <div
                style={{
                  position: 'absolute',
                  top: 0,
                  // top: -100000,
                  width: 300,
                  height: 550,
                }}
                ref={fuelConsumptionDisplayHybridRef}
              >
                <FuelConsumptionDisplayHybrid isPdfReport />
              </div>

              <div
                style={{
                  position: 'absolute',
                  top: 0,
                  // top: -100000,
                  width: 800,
                  height: 550,
                }}
                ref={engineUtilizationRef}
              >
                <EngineUtilizationLine isPdfReport />
              </div>

              {hasJawPressure && 
                <div
                  style={{
                    position: 'absolute',
                    top: 0,
                    // top: -100000,
                    width: 800,
                    height: 550,
                  }}
                  ref={engineCrusherDrivePressureLineRef}
                >
                  <EngineCrusherDrivePressureLine isPdfReport />
                </div>
              }

              {hasJawCloseSideSetting && 
                <div
                  style={{
                    position: 'absolute',
                    top: 0,
                    // top: -100000,
                    width: 800,
                    height: 550,
                  }}
                  ref={engineCloseSideSettingLineRef}
                >
                  <EngineSpezificationLine isPdfReport />
                </div>
              }

              <div
                style={{
                  position: 'absolute',
                  top: 0,
                  // top: -100000,
                  width: 300,
                  height: 550,
                }}
                ref={fuelConsumptionDisplayRef}
              >
                <FuelConsumptionDisplay isPdfReport />
              </div>

              <div
                style={{
                  position: 'absolute',
                  top: 0,
                  // top: -100000,
                  width: 300,
                  height: 550,
                }}
                ref={performanceIndicatorGaugeRef}
              >
                <PerformanceIndicatorGraphGauge isPdfReport />
              </div>

              <div
                style={{
                  position: 'absolute',
                  top: 0,
                  // top: -100000,
                  width: 800,
                  height: 550,
                }}
                ref={fuelConsumptionLineRef}
              >
                <FuelConsumptionLine isPdfReport />
              </div>

              {/* {(hasWeightData || weightDataContent) && (
                <div> */}
                  <div
                    style={{
                      position: 'absolute',
                      top: 0,
                      // top: -100000,
                      width: 300,
                      height: 550,
                    }}
                    ref={throughputDisplayRef}
                  >
                    <ThroughputDisplay isPdfReport />
                  </div>

                  <div
                    style={{
                      position: 'absolute',
                      top: 0,
                      // top: -100000,
                      width: 800,
                      height: 550,
                    }}
                    ref={throughputLineRef}
                  >
                    <ThroughputLine isPdfReport />
                  </div>
                </div>
              {/* )}
            </div> */}
          </Grid>
        ) 
        : (<div
        >
          No Machine!
          </div>
        //null
        )
        }
      </div>
    </Container>
);
}
